/** The import API also takes spreadsheets, so the picker offers them too. */
export const CONTACT_IMPORT_FILE_EXTENSIONS = [
  ".csv",
  ".xlsx",
  ".xls",
] as const;

export const CONTACT_IMPORT_ACCEPTED_FILE_TYPES =
  CONTACT_IMPORT_FILE_EXTENSIONS.join(",");

export const CONTACT_IMPORT_MAX_FILE_SIZE_MB = 50;

export const CONTACT_IMPORT_MAX_FILE_SIZE_BYTES =
  CONTACT_IMPORT_MAX_FILE_SIZE_MB * 1024 * 1024;

export const isContactImportFileName = (fileName: string): boolean => {
  const lower = fileName.toLowerCase();
  return CONTACT_IMPORT_FILE_EXTENSIONS.some((extension) =>
    lower.endsWith(extension)
  );
};

export const getContactImportFileType = (fileName: string): "csv" | "excel" =>
  fileName.toLowerCase().endsWith(".csv") ? "csv" : "excel";
